module.exports = __webpack_public_path__ + "static/img/2.ae7a87e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/2.png
// module id = Djx2
// module chunks = 0